import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { style: {"width":"100%"} }

import InsuranceCancelation from "@/shared/model/InsuranceCancelation";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {useNavigationStore} from "@/modules/Navigation/store";

interface Props {
  data?: InsuranceCancelation,
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceCancelationDetailsComponent',
  props: {
    data: { default: undefined }
  },
  setup(__props: any) {



const props = __props
const _navigationStore = useNavigationStore()

function onInsuranceDetailsClicked() {
  _navigationStore.currentInsuranceId = props.data?.insuranceId
  _navigationStore.currentInsuranceNumber = props.data?.insuranceNumber
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("td", null, "Versicherungsnummer", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.insuranceNumber
          }, null, 8, ["value"]),
          _createVNode(SogButton, {
            "mdi-icon": "mdi-shield",
            tooltip: "Versicherung anzeigen",
            "button-style": _unref(SogButtonStyle).Link,
            onClick: onInsuranceDetailsClicked
          }, null, 8, ["button-style"])
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("tr", null, null, -1)),
      _createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, "Angefragt am", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.cancelationRequestDate,
            "value-type": "DateTime"
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[2] || (_cache[2] = _createElementVNode("td", null, "Stornierungsdatum", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.cancelationDate,
            "value-type": "DateTime"
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[3] || (_cache[3] = _createElementVNode("td", null, "Stornierungsstatus", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.cancelationStatusDescription
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[4] || (_cache[4] = _createElementVNode("td", null, "Kunde", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.personName
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[5] || (_cache[5] = _createElementVNode("td", null, "Prämie", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.grossPrice,
            "value-type": "Money"
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[6] || (_cache[6] = _createElementVNode("td", null, "Versicherungsbetrag", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.insuranceAmount,
            "value-type": "Money"
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[7] || (_cache[7] = _createElementVNode("td", null, "Stornierungsbetrag", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.cancelationAmount,
            "value-type": "Money"
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[8] || (_cache[8] = _createElementVNode("td", null, "Angefragt von", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.data?.cancelationRequestByPersonName
          }, null, 8, ["value"])
        ])
      ])
    ])
  ]))
}
}

})